// extracted by mini-css-extract-plugin
export default {"form_item":"style_form_item__8yJCN","form_title":"style_form_title__mqljo","info_text":"style_info_text__DiIJK"};